/* ================================================
   Pick Your Product – Carousel JS
   ================================================ */

(function () {
  'use strict';

  if (window.PYSCarousel && window.PYSCarousel.booted) return;
  window.PYSCarousel = { booted: true };

  /* ---- Helpers ---- */

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';
  }

  async function addToCart(variantId, quantity) {
    var res = await fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
    });
    if (!res.ok) throw new Error('addToCart failed');
    return res.json();
  }

  function dispatchCartEvent(cart) {
    var e = new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true });
    document.dispatchEvent(e);
    document.documentElement.dispatchEvent(e);
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  /* ---- Init single section ---- */

  function initSection(section) {
    if (!section || section.dataset.pysInitialized === 'true') return;
    if (typeof Splide === 'undefined') return;

    var slider = section.querySelector('.splide');
    var slides = Array.from(section.querySelectorAll('.pys-slide'));
    if (!slider || !slides.length) return;

    section.dataset.pysInitialized = 'true';

    var labels     = Array.from(section.querySelectorAll('[data-label]'));
    var dots       = Array.from(section.querySelectorAll('[data-dot]'));
    var thumb      = section.querySelector('[data-thumb]');
    var slideCount = slides.length;

    /* ---- Find visually centered slide on desktop ---- */

    function getCenteredSlideIndex() {
      if (!isDesktop()) return splide.index;

      var track = slider.querySelector('.splide__track');
      if (!track) return splide.index;

      var trackRect   = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;

      var closestIndex = splide.index;
      var closestDist  = Infinity;

      slider.querySelectorAll('.splide__slide').forEach(function (slideEl) {
        var rect = slideEl.getBoundingClientRect();

        /* Skip slides completely outside viewport */
        if (rect.right <= trackRect.left || rect.left >= trackRect.right) return;

        var slideCenter = rect.left + rect.width / 2;
        var dist        = Math.abs(slideCenter - trackCenter);
        var index       = Number(slideEl.dataset.index);

        if (!isNaN(index) && dist < closestDist) {
          closestDist  = dist;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    /* ---- Set active slide class ---- */

    function setActiveSlide(index) {
      slides.forEach(function (slideEl) {
        var isActive = Number(slideEl.dataset.index) === index;
        slideEl.classList.toggle('is-active', isActive);
        slideEl.classList.toggle('is-current', isActive);
      });
    }

    /* ---- Bottom state (labels, dots, thumb) ---- */

    function setBottomState(index) {
      var i = Math.max(0, Math.min(index, slideCount - 1));

      labels.forEach(function (label) {
        label.classList.toggle('is-active', Number(label.dataset.go) === i);
      });

      dots.forEach(function (dot) {
        dot.classList.toggle('is-hidden', Number(dot.dataset.go) === i);
      });

      if (thumb) {
        var pct = slideCount > 1 ? (i / (slideCount - 1)) * 100 : 0;
        thumb.style.left = pct + '%';
      }
    }

    /* ---- Sync everything ---- */

    function syncState() {
      requestAnimationFrame(function () {
        var activeIndex = getCenteredSlideIndex();
        setBottomState(activeIndex);
        setActiveSlide(activeIndex);
      });
    }

    /* ---- Build Splide options per breakpoint ---- */

    var width = window.innerWidth || document.documentElement.clientWidth || 1024;
    var isDesk = isDesktop();
    var startIndex = (isDesk && slideCount === 3) ? 1 : 0;

    var initialFixedWidth = false;
    var initialAutoWidth  = true;
    var initialGap        = '16px';
    var initialPadding    = { left: '24px', right: '24px' };

    if (width >= 1440) {
      initialFixedWidth = '340px';
      initialAutoWidth  = false;
      initialGap        = '32px';
      initialPadding    = { left: '100px', right: '100px' };
    } else if (width >= 1024) {
      initialFixedWidth = '320px';
      initialAutoWidth  = false;
      initialGap        = '28px';
      initialPadding    = { left: '80px', right: '80px' };
    } else if (width >= 750) {
      initialFixedWidth = '300px';
      initialAutoWidth  = false;
      initialGap        = '24px';
      initialPadding    = { left: '60px', right: '60px' };
    }

    var splideOptions = {
      type        : section.dataset.loop === 'true' && slideCount > 1 ? 'loop' : 'slide',
      focus       : 'center',
      gap         : initialGap,
      arrows      : false,
      pagination  : false,
      drag        : true,
      speed       : 500,
      updateOnMove: true,
      trimSpace   : false,
      rewind      : section.dataset.loop !== 'true',
      mediaQuery  : 'min',
      start       : startIndex,
      autoWidth   : initialAutoWidth,
      fixedWidth  : initialFixedWidth,
      padding     : initialPadding,
      perPage     : 1,

      breakpoints : {
        750: {
          autoWidth  : false,
          fixedWidth : '300px',
          gap        : '24px',
          padding    : { left: '60px', right: '60px' },
          perPage    : 1,
        },
        1024: {
          autoWidth  : false,
          fixedWidth : '320px',
          gap        : '28px',
          padding    : { left: '80px', right: '80px' },
          perPage    : 1,
        },
        1440: {
          autoWidth  : false,
          fixedWidth : '340px',
          gap        : '32px',
          padding    : { left: '100px', right: '100px' },
          perPage    : 1,
        },
      },
    };

    var splide = new Splide(slider, splideOptions);

    /* ---- Click on neighboring slides to center them ---- */

    slides.forEach(function (slideEl) {
      slideEl.addEventListener('click', function (e) {
        var clickedIndex = Number(slideEl.dataset.index);
        var activeIndex  = getCenteredSlideIndex();

        /* Only intercept clicks on non-active slides */
        if (clickedIndex !== activeIndex) {
          /* Don't block CTA clicks */
          if (e.target.closest('[data-add]') || e.target.closest('[data-qty-change]') || e.target.closest('[data-qty-wrap]')) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          splide.go(clickedIndex);
        }
      });
    });

    /* ---- Event delegation for CTA ---- */

    section.addEventListener('click', function (event) {

      /* ── Go-to (labels + dots) ── */
      var goButton = event.target.closest('[data-go]');
      if (goButton && section.contains(goButton)) {
        event.preventDefault();
        splide.go(Number(goButton.dataset.go));
        return;
      }

      /* ── Add to cart ── */
      var addButton = event.target.closest('[data-add]');
      if (addButton && section.contains(addButton)) {
        event.preventDefault();

        var slide     = addButton.closest('.pys-slide');
        var variantId = slide ? String(slide.dataset.variantId) : null;
        if (!variantId) return;

        var qtyWrap = slide.querySelector('[data-qty-wrap]');
        var qtyNum  = slide.querySelector('[data-qty]');
        if (!qtyWrap || !qtyNum) return;

        var qty = Number(qtyNum.textContent) || 1;

        addButton.disabled = true;

        addToCart(variantId, qty)
          .then(function (result) {
            dispatchCartEvent(result);
            addButton.hidden   = false;
            qtyWrap.hidden     = true;
            qtyNum.textContent = '1';
            addButton.disabled = false;
          })
          .catch(function (err) {
            console.error('[PYS] add to cart error', err);
            addButton.disabled = false;
          });

        return;
      }

      /* ── Quantity change ── */
      var qtyButton = event.target.closest('[data-qty-change]');
      if (qtyButton && section.contains(qtyButton)) {
        event.preventDefault();

        var slide2 = qtyButton.closest('.pys-slide');
        if (!slide2) return;

        var qtyNum2    = slide2.querySelector('[data-qty]');
        var qtyWrap2   = slide2.querySelector('[data-qty-wrap]');
        var addButton2 = slide2.querySelector('[data-add]');
        if (!qtyNum2 || !qtyWrap2 || !addButton2) return;

        var delta   = Number(qtyButton.dataset.qtyChange);
        var current = Number(qtyNum2.textContent) || 1;
        var next    = current + delta;

        if (next < 1) {
          qtyWrap2.hidden     = true;
          addButton2.hidden   = false;
          qtyNum2.textContent = '1';
        } else {
          qtyNum2.textContent = next;
        }
      }
    });

    /* ---- Splide events ---- */

    var wasDesktop = isDesktop();

    splide.on('mounted', syncState);
    splide.on('moved', syncState);
    splide.on('resized', function () {
      var nowDesktop = isDesktop();
      if (!wasDesktop && nowDesktop && slideCount === 3 && splide.index === 0) {
        splide.go(1);
      }
      wasDesktop = nowDesktop;
      /* Re-sync after resize with slight delay for layout reflow */
      setTimeout(syncState, 100);
    });
    splide.on('updated', syncState);
    splide.on('refresh', syncState);
    splide.on('drag', syncState);
    splide.on('dragging', syncState);
    splide.on('dragged', syncState);
    splide.on('scroll', syncState);
    splide.on('scrolled', syncState);

    splide.mount();

    /* Initial sync and layout refresh to ensure centered slide */
    splide.refresh();
    syncState();

    /* Re-refresh after reflow, web fonts, and initial render */
    requestAnimationFrame(function () {
      splide.refresh();
      syncState();
    });

    setTimeout(function () {
      splide.refresh();
      syncState();
    }, 100);

    setTimeout(function () {
      splide.refresh();
      syncState();
    }, 300);

    window.addEventListener('load', function () {
      splide.refresh();
      syncState();
    }, { once: true });

    if (window.ResizeObserver) {
      var prevWidth = slider.offsetWidth;
      var ro = new ResizeObserver(function (entries) {
        for (var entry of entries) {
          var cr = entry.contentRect;
          if (cr && Math.round(cr.width) !== prevWidth) {
            prevWidth = Math.round(cr.width);
            splide.refresh();
            syncState();
          }
        }
      });
      ro.observe(slider);
    }

    /* Store splide instance for theme editor access */
    slider.splide = splide;
  }

  /* ---- Init all sections ---- */

  function init(scope) {
    if (typeof Splide === 'undefined') return;
    var root = scope || document;

    if (root.matches && root.matches('[data-pys-section]')) {
      initSection(root);
      return;
    }

    root.querySelectorAll && root.querySelectorAll('[data-pys-section]')
      .forEach(initSection);
  }

  /* ---- Public API ---- */

  window.PYSCarousel.init        = init;
  window.PYSCarousel.initSection = initSection;

  /* ---- Auto-init ---- */

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* ---- Theme editor ---- */

  document.addEventListener('shopify:section:load', function (e) {
    /* Reset initialized flag so it can re-init */
    var sec = e.target.querySelector('[data-pys-section]') || e.target;
    if (sec && sec.dataset) sec.dataset.pysInitialized = '';
    init(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var block   = e.target.closest('.pys-slide');
    var section = e.target.closest('[data-pys-section]');
    if (!block || !section) return;
    var splideRoot = section.querySelector('.splide');
    if (splideRoot && splideRoot.splide) {
      splideRoot.splide.go(Number(block.dataset.index || 0));
    }
  });

})();